import { useEffect, useState } from 'react';

// True while the viewport is narrower than `maxWidth` (default: just under Bootstrap's `md`,
// 768px). Used by ResponsiveTable to switch a wide data table for a stacked-card list - a list
// with a few very verbose columns passes a wider breakpoint so it flips to cards sooner. jsdom
// has no matchMedia (setupTests.js stubs it to a permanent `matches: false`), so tests always
// take the desktop path.
const queryFor = (maxWidth) => `(max-width: ${maxWidth}px)`;

export default function useIsMobile(maxWidth = 767.98) {
  const query = queryFor(maxWidth);
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== 'undefined' && !!window.matchMedia && window.matchMedia(query).matches
  );

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return undefined;
    const mq = window.matchMedia(query);
    const onChange = (e) => setIsMobile(e.matches);
    setIsMobile(mq.matches);
    mq.addEventListener ? mq.addEventListener('change', onChange) : mq.addListener(onChange);
    return () => {
      mq.removeEventListener ? mq.removeEventListener('change', onChange) : mq.removeListener(onChange);
    };
  }, [query]);

  return isMobile;
}
